var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgXrp = function SvgXrp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.536 0 28 0V0C43.464 0 56 12.536 56 28V28C56 43.464 43.464 56 28 56V56C12.536 56 0 43.464 0 28V28Z",
    fill: "#23292F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3126 14.75H43.9376L34.3126 24.28C30.827 27.7294 25.1757 27.7294 21.6876 24.28L12.0588 14.75H16.6876L24.0001 21.9894C25.0655 23.0394 26.5014 23.6281 27.9973 23.6281C29.4932 23.6281 30.929 23.0394 31.9945 21.9894L39.3126 14.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6281 41.25H12L21.6875 31.6612C25.1731 28.2119 30.8244 28.2119 34.3125 31.6612L44 41.25H39.375L32 33.9519C30.9346 32.9018 29.4987 32.3132 28.0028 32.3132C26.5069 32.3132 25.0711 32.9018 24.0056 33.9519L16.6281 41.25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55.5C12.8122 55.5 0.5 43.1878 0.5 28H-0.5C-0.5 43.7401 12.2599 56.5 28 56.5V55.5ZM55.5 28C55.5 43.1878 43.1878 55.5 28 55.5V56.5C43.7401 56.5 56.5 43.7401 56.5 28H55.5ZM28 0.5C43.1878 0.5 55.5 12.8122 55.5 28H56.5C56.5 12.2599 43.7401 -0.5 28 -0.5V0.5ZM28 -0.5C12.2599 -0.5 -0.5 12.2599 -0.5 28H0.5C0.5 12.8122 12.8122 0.5 28 0.5V-0.5Z",
    fill: "#080808",
    fillOpacity: 0.08
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgXrp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "XRP.2d2ac2bab9bb4f0be9cbbebdaff6f98a.svg";